import { HeaderPanel } from '../../HeaderPanel';
import React from 'react';
import { headerPanelOptions, getDetailsItemClasses } from './panelSettings';
import { DetailsHistory } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/EntityDetails/DetailsHistory';
import './History.less';

const detailsHistoryClass = 'dp-entitydetails-history';
interface HistoryPanelProps {
  history?: DetailsHistory[];
}

export function HistoryPanel({ history }: HistoryPanelProps) {
  return (
    <HeaderPanel {...headerPanelOptions('primary', 'History')}>
      <div className={detailsHistoryClass}>
        <ul className={`${detailsHistoryClass}__date`}>
          <li className={getDetailsItemClasses(detailsHistoryClass, true)}>Date</li>
          {history &&
            history.map((h, index) => (
              <li key={index} className={getDetailsItemClasses(detailsHistoryClass, false)} title={h.ModifiedDate}>
                {h.ModifiedDate}
              </li>
            ))}
        </ul>
        <ul className={`${detailsHistoryClass}__account`}>
          <li className={getDetailsItemClasses(detailsHistoryClass, true)}>Account</li>
          {history &&
            history.map((h, index) => (
              <li key={index} className={getDetailsItemClasses(detailsHistoryClass, false)} title={h.ModifiedBy}>
                {h.ModifiedBy}
              </li>
            ))}
        </ul>
      </div>
    </HeaderPanel>
  );
}
